/**
 * Class embodying Load functionality.
 * @memberof Spyral
 * @class
 */
class Load {
	static baseUrl;

	/**
	 * Set the base URL for use with the Load class
	 * @param {string} baseUrl 
	 */
	static setBaseUrl(baseUrl) {
		this.baseUrl = baseUrl;
	}

	/**
	 * Make a call to trombone
	 * @param {object} config 
	 * @param {object} params
	 * @returns {JSON}
	 */
	static trombone(config = {}, params) {
		let url = new URL(config.trombone ? config.trombone : this.baseUrl + "trombone");
		let all = { ...config, ...params };
		for (var key in all) {
			if (all[key] === undefined) { delete all[key] }
		}
		let searchParams = Object.keys(all).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(all[key])).join("&")
		let opt = {};
		if (searchParams.length < 800 || ("method" in all && all["method"] == "GET")) {
			for (var key in all) { url.searchParams.set(key, all[key]); }
		} else {
			opt = {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
				body: searchParams
			}
		}
		return fetch(url.toString(), opt).then(response => {
			if (response.ok) {
				return response.json()
			}
			else {
				return response.text().then(text => {
					if (Voyant && Voyant.util && Voyant.util.DetailedError) {
						new Voyant.util.DetailedError({
							msg: "",
							error: text.split(/(\r\n|\r|\n)/).shift(),
							details: text
						}).showMsg();
					} else {
						alert(text.split(/(\r\n|\r|\n)/).shift())
						if (window.console) { console.error(text) }
					}
					throw Error(text);
				});
			}
		})
	}

	/**
	 * Fetch content from a URL, often resolving cross-domain data constraints
	 * @param {string} urlToFetch 
	 * @param {object} config
	 * @returns {Response}
	 */
	static load(urlToFetch, config) {
		let url = new URL(config && config.trombone ? config.trombone : this.baseUrl + "trombone");
		url.searchParams.set("fetchData", urlToFetch);
		return fetch(url.toString()).then(response => {
			if (response.ok) {
				return response;
			}
			else {
				return response.text().then(text => {
					if (Voyant && Voyant.util && Voyant.util.DetailedError) {
						new Voyant.util.DetailedError({
							error: text.split(/(\r\n|\r|\n)/).shift(),
							details: text
						}).showMsg();
					} else {
						alert(text.split(/(\r\n|\r|\n)/).shift())
						if (window.console) { console.error(text) }
					}
					throw Error(text);
				});
			}
		}).catch(err => { throw err })
	}

	/**
	 * Fetch HTML content from a URL
	 * @param {string} url 
	 * @returns {Document}
	 */
	static html(url) {
		return this.text(url).then(text => new DOMParser().parseFromString(text, 'text/html'));
	}

	/**
	 * Fetch XML content from a URL
	 * @param {string} url 
	 * @returns {XMLDocument}
	 */
	static xml(url) {
		return this.text(url).then(text => new DOMParser().parseFromString(text, 'text/xml'));
	}

	/**
	 * Fetch JSON content from a URL
	 * @param {string} url 
	 * @returns {JSON}
	 */
	static json(url) {
		return this.load(url).then(response => response.json());
	}

	/**
	 * Fetch text content from a URL
	 * @param {string} url 
	 * @returns {string}
	 */
	static text(url) {
		return this.load(url).then(response => response.text());
	}
}

export default Load
